var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base-control",class:( _obj = {}, _obj[_vm.styleType] = true, _obj )},[_c('button',{class:_vm.buttonClass,attrs:{"type":_vm.type,"disabled":_vm.disabled}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }